import './DecisionStatsScreen.css'
import { DefaultScreenProps } from '../defaultScreenProps'
import { useEffect, useRef } from 'react'
import { IMAGES } from 'src/constants/image'
import { Victim } from '../../types/victimTypes'
import { isTvMode } from '../../utils/tvMode'
import { RunHud } from '../../executors/DecisionStatsSceneExecutor'
import { DYNAMIC_COPY } from '../../constants/copy'
import { useSkipNarration } from '../../hooks/useSkipNarration'
import { SkipHint } from '../../components/SkipHint/SkipHint'

const FIRE_TV_APP_URL = 'https://www.amazon.com/dp/B0HFGQMBYL?ref=trolli'

type DecisionStatsScreenProps = DefaultScreenProps & {
  sayVictimStats: () => void
  getDoomedVictim: () => Victim
  getRunHud: () => RunHud
  skipNarration: () => void
}

export const DecisionStatsScreen = ({
  sayVictimStats,
  getDoomedVictim,
  getRunHud,
  skipNarration,
}: DecisionStatsScreenProps) => {
  const audioPlayedRef = useRef(false)

  useEffect(() => {
    if (!audioPlayedRef.current) {
      sayVictimStats()
      audioPlayedRef.current = true
    }
  }, [sayVictimStats])

  useSkipNarration(skipNarration)

  const victim = getDoomedVictim()
  const hud = getRunHud()

  return (
    <div className="decisionStatsScreenContainer">
      {/* Running tally for the run: the number to beat, and the streak
          the type line is about to mock. Top-left, inside the safe area. */}
      <div className="runHud" role="status">
        <span className="runHudCount">
          {DYNAMIC_COPY.BODY_COUNT(hud.bodyCount, hud.runLength)}
        </span>
        {hud.lovedOneStreak >= 2 && (
          <span className="runHudStreak">
            {DYNAMIC_COPY.LOVED_ONE_STREAK(hud.lovedOneStreak)}
          </span>
        )}
      </div>
      <SkipHint />
      <div className="victimTrolleyContainer">
        <img
          className="victimImage"
          src={victim.image}
          alt={`${victim.name}, freshly flattened`}
        />
        <img
          className="trolleyImage"
          src={IMAGES.trolley}
          alt="the angry trolley, victorious"
        />
      </div>
      {/* Web-only cross-promo. Never rendered in TV mode: Amazon prohibits
          store/rating prompts inside Fire TV apps (also hidden by the
          .tv-mode CSS gate in App.css as a belt-and-braces). */}
      {!isTvMode() && (
        <div className="crossPromoFooter">
          <a
            className="crossPromoLink"
            href={FIRE_TV_APP_URL}
            target="_blank"
            rel="noopener noreferrer"
          >
            🔥 Play Trollilopolis on your TV — Get the Fire TV app
          </a>
          <a
            className="crossPromoLink"
            href={FIRE_TV_APP_URL}
            target="_blank"
            rel="noopener noreferrer"
          >
            Enjoying it? Rate us on Amazon
          </a>
        </div>
      )}
    </div>
  )
}
